export default __webpack_public_path__ + "static/media/p-plus-0.6bf5a5d9.svg";